import React from 'react'
import { ShoppingCart } from 'lucide-react'
import { fmtShortDay, money } from '../financial/formatting'
import MiniKpi from './MiniKpi'
import { fmtCount, fmtPct } from './model'

// Leads the partner bought from us, beside what they earned the same day.
// Only for a company with a buyer profile. The backend sends counts and
// totals only - nothing says which affiliate or source a lead came from.
export default function Purchases({ purchases, daily, onOpenBuyer }) {
  // Days with something on them, newest first: a 31-row table of zeros
  // would hide the days that matter.
  const rows = (daily || [])
    .filter((d) => d.api_sold || d.clicks_sold || d.bought_count)
    .slice()
    .reverse()

  return (
    <section id="pw-purchases" className="pw-card" aria-label="Leads you buy from us" style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
        <h2 className="pw-title" style={{ fontSize: 15, fontWeight: 700, display: 'flex', alignItems: 'center', gap: 8 }}>
          <ShoppingCart size={16} aria-hidden="true" style={{ color: 'var(--text-muted)' }} />
          Leads you buy from us
        </h2>
        {onOpenBuyer && (
          <button type="button" className="btn btn-ghost btn-sm" onClick={onOpenBuyer}>
            View purchased leads
          </button>
        )}
      </div>

      <div className="pw-kpis4">
        <MiniKpi label="Purchased" value={fmtCount(purchases.purchased)} />
        <MiniKpi label="Total" value={money(purchases.total)} />
        <MiniKpi label="Avg price" value={money(purchases.avg_price)} />
        <MiniKpi label="Redirect rate" value={fmtPct(purchases.redirect_rate_pct)} hint="Purchased leads whose customer we sent on to your offer." />
      </div>

      {rows.length === 0 ? (
        <span style={{ fontSize: 13, color: 'var(--text-muted)' }}>No sales or purchases in this period.</span>
      ) : (
        <div className="pd-table-scroll">
          <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 360 }}>
            <thead>
              <tr>
                {['Date', 'API sold', 'Clicks sold', 'Your earnings', 'You bought'].map((h, i) => (
                  <th key={h} scope="col" style={{ ...cell, textAlign: i === 0 ? 'left' : 'right', fontSize: 10, fontWeight: 700, letterSpacing: 0.5, textTransform: 'uppercase', color: 'var(--text-muted)' }}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((d) => (
                <tr key={d.date}>
                  <td style={{ ...cell, textAlign: 'left', color: 'var(--text-primary)' }}>{fmtShortDay(d.date)}</td>
                  <td className="pw-num" style={cell}>{fmtCount(d.api_sold)}</td>
                  <td className="pw-num" style={cell}>{fmtCount(d.clicks_sold)}</td>
                  <td className="pw-num" style={cell}>{money(Number(d.api_earnings || 0) + Number(d.clicks_earnings || 0))}</td>
                  <td className="pw-num" style={cell}>
                    {money(d.bought_total)}
                    <span style={{ color: 'var(--text-muted)' }}> · {fmtCount(d.bought_count)}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  )
}

const cell = {
  textAlign: 'right', padding: '9px 6px', fontSize: 12, whiteSpace: 'nowrap',
  color: 'var(--text-secondary)', borderBottom: '1px solid var(--border)',
}
